module.exports = __webpack_public_path__ + "media/images/ico-recording-1354c4be.svg";